<template>
  <div class="discount">
    <div class="hd ly-card">
      <el-button class="fl" @click="openDigFrom(true)" type="primary">新增</el-button>
      <div class="fr">
        <el-input
          v-model.trim="searchFormData.reason"
          placeholder="打折理由名称"
          @keypress.enter.native="search"
        ></el-input>
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      :statusAction="statusAction"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:rate="row">
        {{ row.rate | percent }}
      </template>
      <template v-slot:action="row">
        <template>
          <el-button @click="editRow(row)" type="primary" size="mini">修改</el-button>
          <el-button @click="delRow(row)" type="danger" size="mini">删除</el-button>
        </template>
      </template>
    </ly-table>
    <el-dialog :title="`${defaultFormItem.id ? '修改' : '新增'}打折理由`" :visible.sync="dialogVisible" width="600px">
      <ly-form
        :defaultFormItem="defaultFormItem"
        :formConfig="formConfig"
        :formKeys="formKeys"
        class="discount-form"
        ref="lyForm"
      >
        <template v-slot:rate="{ item, formData }">
          <el-input type="text" :placeholder="item.placeholder" v-model.trim="formData.rate" class="input-short">
            <span slot="append">%</span>
          </el-input>
          <span>(如该折扣率会变化，则留空)</span>
        </template>
      </ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="adDiscount">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Input, Dialog } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { discountTable } from '@/utils/tableHeader';
import { discountFormItem } from '@/utils/formConfig';
import { base } from '@/api';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'Discount',
  components: {
    LyTable,
    LyForm,
    ElInput: Input,
    ElDialog: Dialog
  },
  data() {
    return {
      dialogVisible: false,
      formKeys: discountFormItem,
      defaultFormItem: {},
      formConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      searchFormData: {
        reason: '',
        page_no: 1,
        page_size: 10
      },
      tableHeader: discountTable,
      getTableData: base.getDiscount,
      statusAction: [row => base.activateDiscount({ id: row.id }), row => base.deactivateDiscount({ id: row.id })]
    };
  },
  mounted() {
    this.search();
  },
  filters: {
    percent(value) {
      return typeof value === 'number' ? `${Decimal.mul(value, 100).toNumber()} %` : '一';
    }
  },
  methods: {
    openDigFrom(isAdd) {
      this.dialogVisible = true;
      if (isAdd) {
        this.defaultFormItem = {};
      }
    },
    async adDiscount() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (data.rate) {
          data.rate = Decimal.div(data.rate, 100).toNumber();
        } else {
          delete data.rate;
        }
        if (this.defaultFormItem.id) {
          // 修改
          res = await base.controlDiscount({
            methold: 'put',
            id: this.defaultFormItem.id,
            params: data
          });
          this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        } else {
          // 新增
          res = await base.adDiscount(data);
          this.$store.dispatch('msg/showMsg', res.msg || '新增成功');
        }

        this.$refs.lyTable.setData();
        this.dialogVisible = false;
      }
    },
    delRow(row) {
      this.$confirm('确认删除？')
        .then(() => {
          base
            .controlDiscount({
              methold: 'delete',
              id: row.id
            })
            .then(res => {
              this.search();
              this.$store.dispatch('msg/showMsg', res.msg || '删除成功');
            });
        })
        .catch(() => {});
    },
    editRow(row) {
      /* eslint-disable-next-line no-param-reassign */
      row.isEdit = true;
      this.defaultFormItem = { ...row, rate: row.rate ? Decimal.mul(row.rate, 100).toNumber() : '' };
      this.openDigFrom();
    },
    saveRow() {
      // const data = this.$refs.lyTable.getFormData();
    },
    cancelRow(row) {
      /* eslint-disable-next-line no-param-reassign */
      row.isEdit = false;
    },
    search() {
      this.$refs.lyTable.setData();
    }
  }
};
</script>

<style lang="less">
.discount {
  .hd {
    overflow: hidden;
    .el-input {
      width: 200px;
      margin-right: 20px;
    }
  }
  .input-short {
    width: 202px;
    margin-right: 20px;
  }
}
.discount-form {
  .el-input,
  .el-textarea {
    width: 250px;
  }
}
</style>
